<template>
    <div>
      <van-nav-bar
        title="牛股诊股"
        left-text="返回"
        left-arrow
        @click-left="$router.push('/')"
      />
      <div class="wrap">
        <div class="bg">
          <router-link to="/found_winners">
            <img src="../assets/images/ng_button.png" class="ng_button">
          </router-link>
          <router-link to="/diagnosis_stock">
            <img src="../assets/images/zg_button.png" class="zg_button">
          </router-link>
        </div>
      </div>
    </div>
    </template>
    
    <script>
    export default {
      name: "WinnersDiagnosis",
      data(){
        return{
    
        }
      }
    }
    </script>
    
    <style scoped>
    .wrap{
      width: 100%;
    }
    .bg{
      width: 100%;
      height: 700px;
      background: url("../assets/images/ngzg_new.png") no-repeat;
      background-size: 100% 100%;
    
    }
    .ng_button{
      width: 120px;
      position: absolute;
      top: 192px;
      right: 15px;
    }
    .zg_button{
      width: 120px;
      position: absolute;
      top: 585px;
      left: 15px;
    }
    </style>
    


// WEBPACK FOOTER //
// src/components/WinnersDiagnosis.vue